<template>
    <tr>
        <td>
            <i style="font-size: 30px;" class="guestArrived la" v-bind:class="(guest.arrived ? 'la-check-circle' : 'la-circle')" @click="setArrived()"></i>
        </td>
        <td v-bind:style="{fontWeight:(guest.arrived ? 'bold' : ''),opacity:(guest.arrived ? 1 : 0.8)}">{{ guest.fullName }}</td>
        <td v-bind:style="{fontWeight:(guest.arrived ? 'bold' : ''),opacity:(guest.arrived ? 1 : 0.8)}">{{ guest._group }}</td>

        <td v-if="!tableEdit" @click="tableEdit=true">
            {{ guest.tableNumber ? guest.tableNumber : $t('notSeatedGuest') }}
        </td>
        <td v-if="tableEdit">
            <select v-model="tableID" @change="updateGuest({tableID:tableID,tableNumber:(tableID ? tables.filter(tbl=>tbl.dbID === tableID).map(tbl=>tbl.tableNum)[0] : '' )})">
                <option value="">{{ $t('notSeatedGuest') }}</option>
                <option v-for="table of tables" :key="table.dbID" v-bind:value="table.dbID" v-bind:selected="table.dbID === guest.tableID">{{ table.tableNum }}</option>
            </select>
        </td>

        <td v-if="!amountEdit" @click="amountEdit = true">
            <svg class="i_user"><use xlink:href="#i_user"></use></svg>
            {{ guest.quantity }}
        </td>

        <td v-if="amountEdit">
            <select v-model="amount" @change="updateGuest({quantity:amount })">
                <option v-for="n of 50" v-bind:value="n">{{ n }}</option>
            </select>
        </td>

        <td v-if="!$store.state.isTablet">
            <i style="font-size: 30px;cursor: pointer;" class="guestArrived la la-print" @click="setArrived(true)"></i>
        </td>
    </tr>
</template>

<script>
    import printJS from 'print-js';
    export default {
        name: "GuestArrivalRow",
        props:{
            guest:{
                type:Object,
                default:()=>{return {status:{}}}
            },
            tables:{
                type:Array,
                default:()=>{return []}
            }
        },
        data(){
            return {
                amountEdit:false,
                tableEdit:false,
                tableID:this.guest.tableID,
                amount:this.guest.quantity,
            }
        },
        methods:{
            setArrived(print = false){
                this.guest.arrived = !this.guest.arrived;
                this.updateGuest();
                if(print){
                    this.$emit('print')
                }
            },
            updateGuest(_ = {}){
                this.amountEdit = false;
                this.tableEdit = false;

                const total = Object.values(this.guest.status).reduce((a,b)=>a+b);
                if(_.quantity > total){
                    this.guest.status.coming += _.quantity-total;
                } else if(_.quantity < total){
                    const diff = Math.abs(total - _.quantity);
                    for(let i=1;i<=diff;i++) {
                        if (this.guest.status.notComing > 0) {
                            this.guest.status.notComing--;
                        } else if (this.guest.status.maybeComing > 0) {
                            this.guest.status.maybeComing--;
                        } else if (this.guest.status.notResponded > 0) {
                            this.guest.status.notResponded--;
                        } else if (this.guest.status.coming > 0) {
                            this.guest.status.coming--;
                        } if (this.guest.status.reserve > 0) {
                            this.guest.status.reserve--;
                        }
                    }
                }

                this.$emit('updateGuest',Object.assign(this.guest,_));
            }
        }
    }
</script>
